import { useCallback, useEffect, useState } from "react";
import {
	AgreementRenegotiationService,
	INegotiation,
	INegotiationBalance,
	INegotiationHistoryEntry,
} from "../../../shared/services/api/sinister/AgreementRenegotiationService";

// Não existe menu/tela separada de "Negociações" — negociação É o acordo. Os dados aqui só existem
// quando o sinistro desse acordo já foi incluído numa negociação (fluxo de Renegociar/PR-06);
// acordos "simples" que nunca passaram por isso ficam com negotiation=null.
export const useAgreementNegotiation = (sinisterId: string) => {
	const [negotiation, setNegotiation] = useState<INegotiation | null>(null);
	const [history, setHistory] = useState<INegotiationHistoryEntry[]>([]);
	const [balance, setBalance] = useState<INegotiationBalance | null>(null);
	const [isLoading, setIsLoading] = useState(true);

	const fetchNegotiation = useCallback(async () => {
		if (!sinisterId) {
			setIsLoading(false);
			return;
		}

		setIsLoading(true);
		const found = await AgreementRenegotiationService.findNegotiationBySinisterId(sinisterId);

		if (found instanceof Error || !found) {
			setNegotiation(null);
			setHistory([]);
			setBalance(null);
			setIsLoading(false);
			return;
		}

		setNegotiation(found);

		const [historyResult, balanceResult] = await Promise.all([
			AgreementRenegotiationService.getNegotiationHistory(found.id),
			AgreementRenegotiationService.getNegotiationBalance(found.id),
		]);

		setHistory(historyResult instanceof Error ? [] : historyResult);
		setBalance(balanceResult instanceof Error ? null : balanceResult);
		setIsLoading(false);
	}, [sinisterId]);

	useEffect(() => {
		fetchNegotiation();
	}, [fetchNegotiation]);

	return { negotiation, history, balance, isLoading, refetch: fetchNegotiation };
};
